// constants to reused elsewhere in the application
export const PERMISSIONS = {
  ANALYTICS_POLICIES: {
    READ: 'analytics_policies:read',
  },
  ANALYTICS_PRODUCTIVITY: {
    READ: 'analytics_productivity:read',
  },
  ANALYTICS_SHADOW_IT: {
    READ: 'analytics_shadow_it:read',
  },
  ENDPOINTS_SEARCH: {
    READ: 'endpoints_search:read',
  },
  USER_MANAGEMENT: {
    READ: 'user_management:read',
    WRITE: 'user_management:write',
  },
  CREATE_USERS: {
    WRITE: 'create_users:write',
  },
  DELETE_USERS: {
    WRITE: 'delete_users:write',
  },
  CHANGE_USER_ROLES: {
    WRITE: 'change_user_roles:write',
  },
  VIEW_ADMINS: {
    READ: 'view_admins:read',
  },
  ANALYTICS: {
    READ: 'analytics:read',
    WRITE: 'analytics:write',
  },
  VIEW_POLICIES: {
    READ: 'view_policies:read',
  },
  CREATE_POLICY: {
    WRITE: 'create_policy:write',
  },
  DELETE_POLICY: {
    WRITE: 'delete_policy:write',
  },
  EDIT_POLICY: {
    WRITE: 'edit_policy:write',
    READ: 'edit_policy:read',
  },
  VIEW_POLICY_CONTENT: {
    READ: 'view_policy_content:read',
  },
  VIEW_POLICY_USERS: {
    READ: 'view_policy_users:read',
  },
  VIEW_POLICY_CAC: {
    READ: 'view_policy_cac:read',
  },
  POLICY_BYPASS: {
    READ: 'policy_bypass:read',
    WRITE: 'policy_bypass:write',
  },
  VIEW_POLICY_CONFIGURATION: {
    READ: 'view_policy_configuration:read',
  },
  CHANGE_RESTRICTION_LEVEL: {
    WRITE: 'change_restriction_level:write',
  },
  ADD_EXCEPTION: {
    WRITE: 'add_exception:write',
  },
  CHANGE_BLOCK_PAGES: {
    WRITE: 'change_block_pages:write',
  },
  EDIT_CATEGORY_EXCEPTION: {
    WRITE: 'edit_category_exception:write',
  },
  DELETE_CATEGORY_EXCEPTION: {
    WRITE: 'delete_category_exception:write',
  },
  CHANGE_BLOCK_WARNING_PAGE: {
    WRITE: 'change_block_warning_page:write',
  },
  ADD_CUSTOM_CATEGORIES: {
    WRITE: 'add_custom_categories:write',
  },
  URL_CUSTOM_CATEGORY: {
    WRITE: 'url_custom_category:write',
  },
  ADD_EXCEPTIONS_TO_CUSTOM_CATEGORIES: {
    WRITE: 'add_exceptions_to_custom_categories:write',
  },
  ASSIGN_USERS_TO_POLICY: {
    WRITE: 'assign_users_to_policy:write',
  },
  URL_BYPASS_LIST: {
    WRITE: 'url_bypass_list:write',
  },
  APPLICATION_BYPASS_LIST: {
    WRITE: 'application_bypass_list:write',
  },
  CONFIGURE_CLOUD_APP_CONTROLS: {
    READ: 'configure_cloud_app_controls:read',
    WRITE: 'configure_cloud_app_controls:write',
  },
  POLICY_TESTER: {
    READ: 'policy_tester:read',
  },
  VIEW_ENDPOINTS: {
    READ: 'view_endpoints:read',
  },
  SEARCH_ENDPOINTS: {
    READ: 'search_endpoints:read',
  },
  FILTER_ENDPOINTS: {
    READ: 'filter_endpoints:read',
  },
  ENABLE_DEBUG: {
    WRITE: 'enable_debug:write',
  },
  DOWNLOAD_ENDPOINTS: {
    WRITE: 'download_endpoints:write',
  },
  DISABLE_ENDPOINT: {
    WRITE: 'disable_endpoint:write',
  },
  SETTINGS: {
    READ: 'settings:read',
    WRITE: 'settings:write',
  },
  GENERAL_SETTINGS: {
    WRITE: 'general_settings:write',
    READ: 'general_settings:read',
  },
  USE_BLOCK_PAGES: {
    READ: 'use_block_pages:read',
  },
  BLOCK_PAGES: {
    WRITE: 'block_pages:write',
    READ: 'block_pages:read',
  },
  EDIT_DEFAULT_PAGE_TEXT: {
    WRITE: 'edit_default_page_text:write',
  },
  ADD_CUSTOM_BLOCK_WARNING_PAGES: {
    WRITE: 'add_custom_block_warning_pages:write',
  },
  ENDPOINT_CONFIGURATION: {
    READ: 'endpoint_configuration:read',
    WRITE: 'endpoint_configuration:write',
  },
  REFRESH_ANTI_UNINSTALL_PASSWORD: {
    WRITE: 'refresh_anti_uninstall_password:write',
  },
  COPY_ANTI_UNINSTALL_PASSWORD: {
    READ: 'copy_anti_uninstall_password:read',
    WRITE: 'copy_anti_uninstall_password:write',
  },
  EDIT_FAIL_CLOSED_PARAMETER: {
    WRITE: 'edit_fail_closed_parameter:write',
  },
  CHANGE_ENDPOINT_CONFIGURATION_PARAMETER: {
    WRITE: 'change_endpoint_configuration_parameter:write',
  },
  ADD_ACCEPTABLE_DOMAIN: {
    WRITE: 'add_acceptable_domain:write',
  },
  VIEW_USERS_IMPORT_LINK: {
    READ: 'view_users_import_link:read',
  },
  AUDIT_LOG: {
    READ: 'audit_log:read',
    WRITE: 'audit_log:write',
  },
  SEARCH_AUDIT_LOG: {
    READ: 'search_audit_log:read',
  },
  ADD_S3_BUCKET_LOCATION: {
    WRITE: 'add_s3_bucket_location:write',
    READ: 'add_s3_bucket_location:read',
  },
  SIEM_HTTP: {
    READ: 'siem_http:read',
    WRITE: 'siem_http:write',
  },
  API_KEYS: {
    READ: 'api_keys:read',
    WRITE: 'api_keys:write',
  },
  BILLING_DETAILS: {
    READ: 'billing_details:read',
    WRITE: 'billing_details:write',
  },
  NOTIFICATIONS: {
    READ: 'notifications:read',
  },
  ADD_TO_BYPASS: {
    WRITE: 'add_to_bypass:write',
  },
  VIEW_CASB_OVERVIEW: {
    READ: 'view_casb_overview:read',
  },
  VIEW_CASB_TABLE: {
    READ: 'view_casb_table:read',
  },
  MAKE_PRIVATE: {
    WRITE: 'make_private:write',
  },
  ADD_REVIEW_COMMENT: {
    WRITE: 'add_review_comment:write',
  },
  DOWNLOAD_BUNDLES: {
    READ: 'download_bundles:read',
  },
  SWITCH_ACCOUNTS: {
    READ: 'switch_accounts:read',
  },
  DISPLAY_POLICY_CLASHES: {
    READ: 'display_policy_clashes:read',
  },
  DLP_POLICY_CONFIGURATION: {
    READ: 'dlp_policy_configuration:read',
    WRITE: 'dlp_policy_configuration:write',
  },
  DLP_ADD_EXCEPTION: {
    WRITE: 'dlp_add_exception:write',
  },
  DLP_ADD_BYPASS: {
    WRITE: 'dlp_add_bypass:write',
  },
}

export const config = {
  Administrator: {
    permissions: '*',
  },
  Analyst: {
    permissions: [
      PERMISSIONS.ANALYTICS.READ,
      PERMISSIONS.ANALYTICS.WRITE,
      PERMISSIONS.ANALYTICS_POLICIES.READ,
      PERMISSIONS.ANALYTICS_PRODUCTIVITY.READ,
      PERMISSIONS.ANALYTICS_SHADOW_IT.READ,
      PERMISSIONS.ENDPOINTS_SEARCH.READ,
      PERMISSIONS.VIEW_POLICY_CONTENT.READ,
      PERMISSIONS.VIEW_POLICIES.READ,
      PERMISSIONS.VIEW_POLICY_CONFIGURATION.READ,
      PERMISSIONS.EDIT_CATEGORY_EXCEPTION.WRITE,
      PERMISSIONS.DELETE_CATEGORY_EXCEPTION.WRITE,
      PERMISSIONS.ADD_EXCEPTION.WRITE,
      PERMISSIONS.USE_BLOCK_PAGES.READ,
      PERMISSIONS.CHANGE_BLOCK_PAGES.WRITE,
      PERMISSIONS.URL_CUSTOM_CATEGORY.WRITE,
      PERMISSIONS.ADD_EXCEPTIONS_TO_CUSTOM_CATEGORIES.WRITE,
      PERMISSIONS.CONFIGURE_CLOUD_APP_CONTROLS.READ,
      PERMISSIONS.POLICY_TESTER.READ,
      PERMISSIONS.VIEW_ENDPOINTS.READ,
      PERMISSIONS.DOWNLOAD_ENDPOINTS.WRITE,
      PERMISSIONS.SEARCH_ENDPOINTS.READ,
      PERMISSIONS.FILTER_ENDPOINTS.READ,
      PERMISSIONS.ENABLE_DEBUG.WRITE,
      PERMISSIONS.DISABLE_ENDPOINT.WRITE,
      PERMISSIONS.AUDIT_LOG.READ,
      PERMISSIONS.SEARCH_AUDIT_LOG.READ,
      PERMISSIONS.VIEW_CASB_OVERVIEW.READ,
      PERMISSIONS.VIEW_CASB_TABLE.READ,
      PERMISSIONS.DOWNLOAD_BUNDLES.READ,
      PERMISSIONS.SWITCH_ACCOUNTS.READ,
      PERMISSIONS.DISPLAY_POLICY_CLASHES.READ,
      PERMISSIONS.DLP_POLICY_CONFIGURATION.READ,
      PERMISSIONS.DLP_ADD_EXCEPTION.WRITE,
    ],
  },
  'Read-Only': {
    permissions: [
      PERMISSIONS.ANALYTICS.READ,
      PERMISSIONS.ANALYTICS_POLICIES.READ,
      PERMISSIONS.ANALYTICS_PRODUCTIVITY.READ,
      PERMISSIONS.ANALYTICS_SHADOW_IT.READ,
      PERMISSIONS.ENDPOINTS_SEARCH.READ,
      PERMISSIONS.VIEW_POLICY_CONTENT.READ,
      PERMISSIONS.VIEW_POLICIES.READ,
      PERMISSIONS.VIEW_POLICY_USERS.READ,
      PERMISSIONS.VIEW_POLICY_CAC.READ,
      PERMISSIONS.POLICY_BYPASS.READ,
      PERMISSIONS.VIEW_POLICY_CONFIGURATION.READ,
      PERMISSIONS.CONFIGURE_CLOUD_APP_CONTROLS.READ,
      PERMISSIONS.POLICY_TESTER.READ,
      PERMISSIONS.VIEW_ENDPOINTS.READ,
      PERMISSIONS.SEARCH_ENDPOINTS.READ,
      PERMISSIONS.FILTER_ENDPOINTS.READ,
      PERMISSIONS.BLOCK_PAGES.READ,
      PERMISSIONS.USE_BLOCK_PAGES.READ,
      PERMISSIONS.ENDPOINT_CONFIGURATION.READ,
      PERMISSIONS.USER_MANAGEMENT.READ,
      PERMISSIONS.COPY_ANTI_UNINSTALL_PASSWORD.READ,
      PERMISSIONS.AUDIT_LOG.READ,
      PERMISSIONS.ADD_S3_BUCKET_LOCATION.READ,
      PERMISSIONS.API_KEYS.READ,
      PERMISSIONS.SEARCH_AUDIT_LOG.READ,
      PERMISSIONS.VIEW_CASB_OVERVIEW.READ,
      PERMISSIONS.VIEW_CASB_TABLE.READ,
      PERMISSIONS.DOWNLOAD_BUNDLES.READ,
      PERMISSIONS.SWITCH_ACCOUNTS.READ,
      PERMISSIONS.DISPLAY_POLICY_CLASHES.READ,
      PERMISSIONS.SIEM_HTTP.READ,
      PERMISSIONS.DLP_POLICY_CONFIGURATION.READ,
    ],
  },
}

export type Role = keyof typeof config
export type Permissions = Permissions[] | string
